<motn-tile [rawTile]="rawTile"></motn-tile>
